<template>
  <div>
    <v-layout row wrap fill-height class="mapheight">
      <v-flex d-flex xs12 sm5 md6 lg7 xl8 class="hidden-xs-only" >
        <GmapMap
          ref="mapRef"
          :center="{lat:currentLocation.lat, lng:currentLocation.lng}"
          :zoom="14"
          map-type-id="roadmap"
          :options="{styles: styles}"
         v-if="this.currentLocation.lat > 0"
        >
          <gmap-info-window :options="infoOptions" :position="infoWindowPos" :opened="infoWinOpen" @closeclick="infoWinOpen=false">
            {{infoContent}}
          </gmap-info-window>
          <GmapMarker
            v-for="(betrieb, index) in filterItems(this.$store.getters.fetchBetriebe.betriebe)"
            :key="betrieb.id"
            :position="{lat: parseFloat(betrieb.geo_lat), lng: parseFloat(betrieb.geo_lng)}"
            :clickable="true"
            :draggable="false"
            :animation="betrieb.id == current ? 1 : 0"
            @click="toggleInfoWindow(betrieb,index)"
            :class="{current:betrieb.id == current}"
            :id="'MarkerID' + betrieb.id"
          ></GmapMarker>
          <GmapMarker
            ref="eigenePosition"
            :position="{lat: parseFloat(currentLocation.lat), lng: parseFloat(currentLocation.lng)}"
            :clickable="true"
            :draggable="true"
            @dragend="getMarkerPosition"
            @click="getMarkerPosition"
            :animation="2"
            :icon="'././img/location37_b.png'"
            :zIndex="500"
          >
            <!-- <gmap-info-window
              v-if="this.$store.getters.fetchBetriebe.standortwert[0].typ < 3"
            >
            {{ StandortMarkerBeschriftung }}
            </gmap-info-window> -->
          </GmapMarker>
        </GmapMap>
        <div v-else class="ma-5">
            <div v-if="!this.currentLocation.lat">
                  <Stadt-Waehlen :location="currentLocation" @StadtGewaehlt="ZeigeKarte"></Stadt-Waehlen>
                </div>
       
        </div>
    
      </v-flex>
      <v-flex xs12 sm7 md6 lg5 xl4>
        <v-flex>
          <v-card raised>
            <v-card-title class="pb-0 pt-2">
              <div v-if="filterItems(this.$store.getters.fetchBetriebe.betriebe).length > 1">
                <span class="subheading ma-0 mr-1 pa-0">
                  <v-icon small>list</v-icon>
                  {{ filterItems(this.$store.getters.fetchBetriebe.betriebe).length }} Betriebe gefunden
                </span>
              </div>
              <div v-else-if="filterItems(this.$store.getters.fetchBetriebe.betriebe).length === 1">
                <span class="subheading ma-0 mr-1 pa-0">Einen passenden Betrieb gefunden</span>
              </div>
              <v-spacer xclass="hidden-sm-and-down"></v-spacer>
              <span class="subheading ma-0 pa-0">
                <v-icon small>location_searching</v-icon> Standort: {{ this.standortart }}
              </span>
            </v-card-title>
            <v-card-text class="ma-0 pb-0 pt-1">
              <v-container class="pa-0 ma-0">
                <v-layout row>
                  <v-flex
                    xs9
                    sm8
                    md6
                    lg6
                    class="pb-2"
                    style="min-width: 275px; xborder: 1px solid red;"
                  >
                    <span class="subheading">
                      <v-icon small>sort</v-icon> Sortieren nach:
                    </span>
                    <br>
                    <v-btn-toggle v-model="sort" mandatory>               
                        <v-btn flat value="name">
                          <span>Name</span>
                          <v-icon>text_rotate_vertical</v-icon>
                        </v-btn>              
                        <v-btn flat value="entfernung">
                          <span>Entfernung</span>
                          <v-icon>my_location</v-icon>
                        </v-btn>
                        <v-btn flat value="beste">
                          <v-icon>verified_user</v-icon>
                        </v-btn>
                    </v-btn-toggle>
                  </v-flex>
                  <v-flex
                    xs6
                    sm4 offset-sm0
                    md5 offset-md1
                    lg5 offset-lg1
                    class="hidden-xs-only"
                    justify-end
                  >
                    <v-text-field
                      name="filter"
                      label="Filter nach Name"
                      browser-autocomplete="false"
                      v-model="filter"
                      append-icon="search"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
          </v-card>
          <v-divider></v-divider>
        </v-flex>
        
        <v-flex class="scrollspalte" id="scrolltainer">
          <v-layout wrap>
            <v-flex xs12>

              <div v-if="this.$store.getters.fetchBetriebe.betriebe.length === 0" style="width: 100%;">
                <div class="mt-5" v-if="this.currentLocation.lat > 0">
                  <div class="text-xs-center" v-if="loading">
                    <v-progress-circular 
                      :size="70"
                      :width="7"
                      color="accent"
                      indeterminate
                    ></v-progress-circular>
                  </div>
                  
                   <Nichts-Gefunden v-if="!loading" ></Nichts-Gefunden>
                </div>
                 <div v-if="!this.currentLocation.lat">
                  <Stadt-Waehlen :location="currentLocation" @StadtGewaehlt="ZeigeKarte"></Stadt-Waehlen>
                </div>
                
                
              <!-- a  {{ this.currentLocation }} b: {{ this.currentLocation.lat }} -->
               
              </div>

     
              <MapCard
                v-else
                ref="mapCardRef"
                :betriebe="filterItems(this.$store.getters.fetchBetriebe.betriebe)"
                :standort="currentLocation"
                :current="current"
                :sort="sort"
                @MapPan="setCurrentundPan"
                @MapSetCurrent="setCurrent"
              ></MapCard>
            <!-- {{ this.currentLocation}}   location {{ this.$route.name }} {{ mapKey }} {{ this.mapKey }} -->
            </v-flex>
            <!-- <v-flex class="pa-3" v-if="!istDefaultLeistung">
              <v-btn
                color="accent"
                block
                @click="vuexBetriebe()"
                v-if="DefaultLeistungName"
                :loading="busy"
                large
                class="mapCardWrap"
              >{{ DefaultLeistungName }}</v-btn>
            </v-flex> -->
            <v-flex class="pa-3">
              <span v-for="leistung in this.$store.state.suche.leistung" :key="leistung.id" >
                <LeistungAusweitenButtons 
                  :leistung="leistung" 
                  v-if="leistung.id != leistung.gewerk.defaultleistung_id"
                ></LeistungAusweitenButtons>
              </span>

            </v-flex>

          </v-layout>
        </v-flex>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>

const VueScrollTo = require('vue-scrollto')

// import axios from 'axios'
import MapCard from '~/components/MapCard.vue'
import LeistungAusweitenButtons from '~/components/startseite/LeistungAusweitenButtons.vue'

import NichtsGefunden from '~/components/karte/NichtsGefunden.vue'
import StadtWaehlen from '~/components/karte/StadtWaehlen.vue'

import { mapGetters } from 'vuex'
// import { mapMutations } from 'vuex'

export default {
  components: {
    MapCard,
    LeistungAusweitenButtons,
    NichtsGefunden,
    StadtWaehlen
  },

  methods: {
    ScrollZuBetrieb: function (id) {
      var scrolltarget
      scrolltarget = '#betriebID' + id
      VueScrollTo.scrollTo(scrolltarget)

      this.current = id

      this.currentID = 'MarkerID' + id
    },
    // marker info box
    toggleInfoWindow: function (marker, idx) {
      var posi = { lat: marker.geo_lat, lng: marker.geo_lng }
      this.infoWindowPos = posi
      this.infoContent = marker.name

      // check ob bereits offen
      if (this.currentMidx === idx) {
        this.infoWinOpen = !this.infoWinOpen
      } else {
        this.infoWinOpen = true
        this.currentMidx = idx
      }

      this.ScrollZuBetrieb(marker.id)
    },
    ZeigeKarte: function (gewaehltestadt) {
      console.log('zeigekarte')
      console.log(gewaehltestadt)
      var fakemarker = { fake: true, lat: gewaehltestadt.geo_lat, lng: gewaehltestadt.geo_lng }

      this.getMarkerPosition(fakemarker)
      this.karteversteckt = false
    },
    ScrollNurHoch () {
      VueScrollTo.scrollTo('#scrollcontainertop')
    },
    async getMarkerPosition (marker) {
      if (marker.fake) {
        this.currentLocation.lat = marker.lat
        this.currentLocation.lng = marker.lng
      } else {
        this.currentLocation.lat = marker.latLng.lat()
        this.currentLocation.lng = marker.latLng.lng()
      }
      console.log('mach loading true')
      this.loading = true

      var payload = {
        'lat': this.currentLocation.lat,
        'lng': this.currentLocation.lng,
        'betriebe': true
      }
      console.log(payload)
      if (this.$route.name === 'indernaehe') {
        this.loading = true
       // if !this.currentLocation.lat return
        await this.$store.dispatch('neueMarkerPosiGetBetriebe', payload).then(() => {
          console.log('mach loading false')
          this.loading = false
        })
      } else {
        this.$store.dispatch('neueMarkerPosi', payload)
      }
      this.ScrollNurHoch()
    },

    scrollzumir: function () {
      var ichlng
      var ichlat

      ichlat = this.$store.getters.fetchBetriebe.standortwert[0].lat
      ichlng = this.$store.getters.fetchBetriebe.standortwert[0].lng

      console.log('scoll zu lng: ' + ichlng + ', lat: ' + ichlat)
      this.$refs.mapRef.panTo({

        lat: ichlat,
        lng: ichlng

      })
    },

    panToB: function ($lat, $lng, $id) {
      this.current = $id
      this.$refs.mapRef.panTo({

        lat: $lat,
        lng: $lng

      })
    },
    setCurrent (current) {
      this.current.id = current
      console.log('current set')
    },
    setCurrentundPan ($lat, $lng, $id) {
      this.current = $id

      if (this.infoWinOpen) {
        this.infoWinOpen = !this.infoWinOpen
      }
      this.$refs.mapRef.panTo({

        lat: $lat,
        lng: $lng

      })
    },

    geolocation: function () {
      console.log('versuche geolocate und set default')

      // this.$ga.event({
      //   eventCategory: 'geolocate',
      //   eventAction: 'Versuche Geolocation'
      // })

      if (this.$store.getters.fetchBetriebe.standortwert[0].lat) {
        this.currentLocation.lat = this.$store.getters.fetchBetriebe.standortwert[0].lat
        this.currentLocation.lng = this.$store.getters.fetchBetriebe.standortwert[0].lng
        this.currentLocation.typ = this.$store.getters.fetchBetriebe.standortwert[0].typ
      }
        // check ob schon vorhanden in VUEX
      if (this.currentLocation.lat) {
        if (this.currentLocation.typ > 1) {
          console.log('geolocate break..')
          return
        }
      }

      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(position => {
          this.currentLocation = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
            accuracy: position.coords.accuracy
          }
          console.log('geolocate genauigkeit: ' + this.currentLocation.accuracy + 'm')

          // if (this.currentlocation) {
          //   this.$ga.event({
          //     eventCategory: 'geolocate',
          //     eventAction: 'Erfolg',
          //     eventValue: this.currentlocation.accuracy
          //   })
          // }

          if (this.currentLocation.accuracy > 2000) {
            console.log(this.currentLocation.accuracy + 'm genauigkeit, alter lat: ' + this.currentLocation.lat)

            this.currentLocation.lat = this.$store.getters.fetchBetriebe.standortwert[0].lat
            this.currentLocation.lng = this.$store.getters.fetchBetriebe.standortwert[0].lng
            console.log('neu lat:' + this.currentLocation.lat)

            if (this.$route.name === 'indernaehe') {
              console.log('fallback indernaehe')
              this.currentLocation.lat = ''
              this.currentLocation.lng = ''
              this.karteversteckt = true
            }
          } else {
            var payload = {
              'lat': this.currentLocation.lat,
              'lng': this.currentLocation.lng,
              'accuracy': this.currentLocation.accuracy
            }

            if (this.$route.name === 'indernaehe') {
              const payloadobject = {
                lat: this.currentLocation.lat,
                lng: this.currentLocation.lng,
                accuracy: this.currentLocation.accuracy
              }
              // this.$store.dispatch('neueGeolocatePosiGetBetriebe', payloadobject)
              this.$store.dispatch('neueMarkerPosiGetBetriebe', payloadobject)
            } else {
              this.$store.dispatch('neueGeolocatePosi', payload)
            }
          }
        })
        console.log('geolocation fertig..')
      } else {
             // keine geolocation verfügbar im browser

        console.log('keine geolocation verfügbar, zentriere auf standort der suche')
        this.currentLocation.lat = this.$store.getters.fetchBetriebe.standortwert[0].lat
        this.currentLocation.lng = this.$store.getters.fetchBetriebe.standortwert[0].lng

        // this.$ga.event({
        //   eventCategory: 'geolocate',
        //   eventAction: 'fehler, Standort auf default gesetzt'
        // })
        console.log('geolocation nicht verfügbar, setze standort auf default..')
      }
    },
    filterItems: function (presets) {
      var betriebsfilter = this
      return presets.filter(function (preset) {
        const regex = new RegExp('(' + betriebsfilter.filter + ')', 'i')
        return preset.name.match(regex)
      })
    },
    // FetchBetriebe für Erweiterte Suche
    async vuexBetriebe () {
      this.busy = true
      var payload = {
        leistung: this.$store.getters.fetchSuchbegriff.gewerk.defaultleistung_id,
        standort: this.$store.getters.fetchBetriebe.standortwert[0].name,
        erweitert: true
      }
     // console.log(payload)
      await this.$store.dispatch('fetchBetriebe', payload)
      // var gaevent = this.Leistung
      // this.$ga.event({
      //   eventCategory: 'Betriebssuche',
      //   eventAction: 'Suche ausgeweitet',
      //   eventValue: gaevent
      // })
      this.busy = false
      this.$emit('busy', false)
    }
  },
  mounted: function () {
    this.geolocation()
  },
  computed: {
    // mix the getters into computed with object spread operator
    ...mapGetters([
      'fetchBetriebe'
      // ...
    ]),
    standortart: function () {
      var standortmeldung
      var StandortTyp
      StandortTyp = this.$store.getters.fetchBetriebe.standortwert[0].typ

      switch (StandortTyp) {
        case 1:
          standortmeldung = 'Ungenau'
          break
        case 2:
          if (this.$store.getters.fetchBetriebe.standortwert[0].accuracy < 100) {
            standortmeldung = 'Genau (< 100m)'
            break
          }
          if (this.$store.getters.fetchBetriebe.standortwert[0].accuracy < 500) {
            standortmeldung = 'Genau (< 500m)'
            break
          }
          if (this.$store.getters.fetchBetriebe.standortwert[0].accuracy < 1000) {
            standortmeldung = 'Genau (< 1km)'
            break
          }
          if (this.$store.getters.fetchBetriebe.standortwert[0].accuracy < 2000) {
            standortmeldung = 'Genau (< 2km)'
            break
          }
          if (this.$store.getters.fetchBetriebe.standortwert[0].accuracy < 3000) {
            standortmeldung = 'Relativ genau (< 3km)'
            break
          }
          if (this.$store.getters.fetchBetriebe.standortwert[0].accuracy > 3001) {
            standortmeldung = 'Ungenau (> 3km)'
            break
          }
          standortmeldung = 'Ungenau'
          break
        case 3:
          standortmeldung = 'Manuell eingestellt'
          break
      }
      return standortmeldung
    },
    mapKey () {
      const mapKey = this.$route.name
      return mapKey
    },
    StandortMarkerBeschriftung () {
      if (this.$store.getters.fetchBetriebe.standortwert[0].typ === 1) {
        return 'Mittelpunkt'
      } else if (this.$store.getters.fetchBetriebe.standortwert[0].typ === 2) {
        return 'Ihr erkannter Standort, kann manuell verschoben werden.'
      } else {
        return 'Ausgangspunkt'
      }
    },
    istDefaultLeistung () {
      if (this.$store.getters.fetchSuchbegriff.gewerk) {
        var istDefaultLeistung = this.$store.getters.fetchSuchbegriff.id === this.$store.getters.fetchSuchbegriff.gewerk.defaultleistung_id
        return istDefaultLeistung
      }
    },
    DefaultLeistungName () {
      if (this.$store.getters.fetchSuchbegriff.gewerk) {
        var text = 'Suche ausweiten auf ' + this.$store.getters.fetchSuchbegriff.gewerk.name
        return text
      }
    }
  },
  data () {
    return {
      aktuelleposi: '',
      test123: '',
      center: '',
      testing: '',
      marker: '',
      karteversteckt: false,
      busy: false,
      currentLocation: { lat: 42.4255566, lng: 7.0314511, typ: '' },
      searchAddressInput: '',
      filter: '',
      current: '',
      currentID: '',
      sort: 'beste',
      value: true,
      loading: false,
      statusText: '',
      betrieb: {
        logo: null,
        name: null
      },
      standorttest: 'bla',
      infoContent: '',
      infoWindowPos: this.currentLocation,
      infoWinOpen: false,
      currentMidx: null,
        // optional: offset infowindow so it visually sits nicely on top of our marker
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -45
        }
      },

      styles: [
        {
          'featureType': 'administrative',
          'elementType': 'all',
          'stylers': [
            {
              'hue': '#000000'
            },
            {
              'lightness': -100
            },
            {
              'visibility': 'off'
            }
          ]
        },
        {
          'featureType': 'administrative.locality',
          'elementType': 'all',
          'stylers': [
            {
              'visibility': 'on'
            },
            {
              'saturation': '-3'
            },
            {
              'gamma': '1.81'
            },
            {
              'weight': '0.01'
            },
            {
              'hue': '#ff0000'
            },
            {
              'lightness': '17'
            }
          ]
        },
        {
          'featureType': 'administrative.land_parcel',
          'elementType': 'all',
          'stylers': [
            {
              'visibility': 'off'
            }
          ]
        },
        {
          'featureType': 'landscape',
          'elementType': 'geometry',
          'stylers': [
            {
              'hue': '#dddddd'
            },
            {
              'saturation': -100
            },
            {
              'lightness': -3
            },
            {
              'visibility': 'on'
            }
          ]
        },
        {
          'featureType': 'landscape',
          'elementType': 'labels',
          'stylers': [
            {
              'hue': '#000000'
            },
            {
              'saturation': -100
            },
            {
              'lightness': -100
            },
            {
              'visibility': 'off'
            }
          ]
        },
        {
          'featureType': 'poi',
          'elementType': 'all',
          'stylers': [
            {
              'hue': '#000000'
            },
            {
              'saturation': -100
            },
            {
              'lightness': -100
            },
            {
              'visibility': 'off'
            }
          ]
        },
        {
          'featureType': 'road',
          'elementType': 'geometry',
          'stylers': [
            {
              'hue': '#bbbbbb'
            },
            {
              'saturation': -100
            },
            {
              'lightness': 26
            },
            {
              'visibility': 'on'
            }
          ]
        },
        {
          'featureType': 'road',
          'elementType': 'labels',
          'stylers': [
            {
              'hue': '#ffffff'
            },
            {
              'saturation': -100
            },
            {
              'lightness': 100
            },
            {
              'visibility': 'off'
            }
          ]
        },
        {
          'featureType': 'road.arterial',
          'elementType': 'labels.text',
          'stylers': [
            {
              'visibility': 'on'
            },
            {
              'color': '#797979'
            }
          ]
        },
        {
          'featureType': 'road.arterial',
          'elementType': 'labels.text.fill',
          'stylers': [
            {
              'color': '#868686'
            }
          ]
        },
        {
          'featureType': 'road.arterial',
          'elementType': 'labels.text.stroke',
          'stylers': [
            {
              'color': '#ffffff'
            }
          ]
        },
        {
          'featureType': 'road.local',
          'elementType': 'all',
          'stylers': [
            {
              'hue': '#ff0000'
            },
            {
              'saturation': -100
            },
            {
              'lightness': 100
            },
            {
              'visibility': 'on'
            }
          ]
        },
        {
          'featureType': 'road.local',
          'elementType': 'labels.text',
          'stylers': [
            {
              'visibility': 'on'
            }
          ]
        },
        {
          'featureType': 'road.local',
          'elementType': 'labels.text.fill',
          'stylers': [
            {
              'color': '#b6b2b2'
            }
          ]
        },
        {
          'featureType': 'transit',
          'elementType': 'labels',
          'stylers': [
            {
              'hue': '#ff0000'
            },
            {
              'lightness': -100
            },
            {
              'visibility': 'off'
            }
          ]
        },
        {
          'featureType': 'water',
          'elementType': 'geometry',
          'stylers': [
            {
              'hue': '#ff0000'
            },
            {
              'saturation': -100
            },
            {
              'lightness': 100
            },
            {
              'visibility': 'on'
            }
          ]
        },
        {
          'featureType': 'water',
          'elementType': 'labels',
          'stylers': [
            {
              'hue': '#000000'
            },
            {
              'saturation': -100
            },
            {
              'lightness': -100
            },
            {
              'visibility': 'off'
            }
          ]
        }
      ]
    }
  }
}
</script>

<!-- Style schaltet Gmaps Impressum aus -->
<style >

.gm-style-cc {
  display: none;
}
.scrollspalte {
  /* height: calc(100vh - 10.5rem); */
  height: calc(100vh - 16rem);
  overflow-y: scroll;
}

.v-btn.mapCardWrap .v-btn__content {
  white-space: normal;
}
.xxcurrent {
  background: rgb(56, 184, 131);
}
.cardbackground {
  background: no-repeat center;
}
.mouseoverlink {
  cursor: pointer;
}
.mapheight {
  /* height: calc(100vh - 10.5rem); */
   height: calc(100vh - 10.4rem); 
}

</style>